import { render, staticRenderFns } from "./ele4.vue?vue&type=template&id=71c7e7eb&scoped=true"
import script from "./ele4.vue?vue&type=script&lang=js"
export * from "./ele4.vue?vue&type=script&lang=js"
import style0 from "./ele4.vue?vue&type=style&index=0&id=71c7e7eb&prod&lang=scss"
import style1 from "./ele4.vue?vue&type=style&index=1&id=71c7e7eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7e7eb",
  null
  
)

export default component.exports